import React from "react";
import VendorEditContent from "./components/OfficerVendorEditContent";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import LocalStorage from "../../utilities/localStorage";
import { Navigate } from "react-router-dom";

const VendorEdit = () => {
  const role = LocalStorage.getItem("tata_login_user")?.roles[0];

  if (role !== "super admin") {
    return <Navigate to="/app" />;
  }

  return (
    <div>
      <TitleHolder>Vendor Edit</TitleHolder>
      <StepperContentHolder>
        <VendorEditContent />
      </StepperContentHolder>
    </div>
  );
};

export default VendorEdit;
